store.admin.codename = {};
store.admin.codename.init = function(name, action) {
	$('#' + name).change(function(){
		$('#' + name + '_placeholder').val(this.value);
	});
	$('#elm_' + name + ' input.codenameButton').click(function(e) {
		var url = this.form.action.replace(/\?.*/, '');
		url = url.replace(/\/[^/]+(\/\d+)?$/, '/'+action+'$1')+'?r='+name;
		var dialog = $('<div id="codenameDialog" style="display:none" class="loading"></div>').appendTo($('#elm_' + name));
		dialog.data('actionUrl', url);
		dialog.dialog({
			modal: true,
			width: 450,
			position: {
				my: 'center',
				at: 'top+150px'
			},
			close: function(/*e, ui*/) {
				dialog.remove();
			}
		});
		dialog.load(
			url,
			function (/*text, status, XMLHttpRequest*/) {
				dialog.removeClass('loading');
			}
		);
		e.preventDefault();
		return false;
	});
};
store.admin.codename.initChange = function(returnTo, action) {
	var $x_codename = $('#x_codename');
	var $codenameDialog = $('#codenameDialog');
	var $ret = $('#'+returnTo);
	$x_codename.val($ret.val());
	var t = $codenameDialog.find('form').attr('data-title');
	$codenameDialog.dialog('option','title', t);
	$('#codenameSubmit').click(function(e){
		$ret.val($x_codename.val());
		$ret.trigger('change');
		$codenameDialog.dialog('close');
		e.preventDefault();
		return false;
	});

	// disable enter
	$x_codename.keypress(function(e) {
		if (e.keyCode == 13 || e.keyCode == 13) {
			e.preventDefault();
		}
	});

	$x_codename.data('timeout',null).keyup(function(){
		clearTimeout($(this).data('timeout'));
		$(this).data('timeout', setTimeout(function() {
			var $codenameInput = $('#x_codename');
			$('#codenameStatus').attr('class', 'loading').text(' ');
			var codenameVal = $codenameInput.val();
			store.admin.codename.highlight(codenameVal);
			$('#codenameSubmit').removeAttr('disabled');
			var url = $codenameDialog.data('actionUrl').replace(/\/[^/]+(\/\d+(\?.*))?$/, '/'+action+'$1');
			$.ajax({
				url: url,
				data: { n: codenameVal},

				dataType: 'json',
				success: function (data/*, textStatus, jqXHR*/) {
					if (data.error) {
						$('#codenameStatus').attr('class', 'error').text(data.error);
						$('#codenameSubmit').attr('disabled','disabled');
					}
					else {
						if (data.suggest) {
							store.admin.codename.highlight(data.suggest, codenameVal);
						}
						$('#codenameStatus').attr('class', 'success').text(' ');
					}
				}
			});
		}, 500));
	});
};
store.admin.codename.highlight = function(value, codenameVal){
	$('.urlList li').each(function() {
		var t = $(this);
		var c = t.text();
		if (!codenameVal) {
			// now we don't have anything after a "/", so we just throw in some temp char
			c += 't';
		}
		var x = c.replace(/\/[^/]+$/, '/' + '<span class="highlight">'+value+'</span>');
		t.html(x);
	});
};
